import { render, staticRenderFns } from "./ProjectUsersPermissions.vue?vue&type=template&id=15e7dc48&scoped=true"
import script from "./ProjectUsersPermissions.vue?vue&type=script&lang=js"
export * from "./ProjectUsersPermissions.vue?vue&type=script&lang=js"
import style0 from "./ProjectUsersPermissions.vue?vue&type=style&index=0&id=15e7dc48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e7dc48",
  null
  
)

export default component.exports